export var version = '3.5.10';
//# sourceMappingURL=version.js.map